// 3_pages/kariera.js
// Careers page (/kariera/, [page-name-selector="kariera"]): jobs from JSON, accordion, apply form.

const JOBS_JSON_URL = "/user/documents/upload/shoptet_uploads/kariera/kariera.json";
const APPLY_ENDPOINT =
	"https://script.google.com/macros/s/AKfycbyRMLjb2ri0Gp2gvWjkT6LMdBkQikMjWUWfo9WIImndeENaVt51ulloR-a5xBw8p4QXtw/exec";
const MAX_CV_BYTES = 10 * 1024 * 1024;
const CV_TYPES = ["pdf", "doc", "docx"];
const META_FIELD_KEYS = {
	salary: true,
	start: true,
	contractDuration: true,
	contractType: true,
};

export function init() {
	if (!document.querySelector('[page-name-selector="kariera"]')) return;

	bindHeroArrow();

	loadPositions().then(function (positions) {
		renderJobs(positions);
		bindJobDropdowns();
		initApplyForm(positions);
	});
}

function bindHeroArrow() {
	const arrowSectionDown = document.querySelector(".arrow-section-down");
	const secondSection = document.querySelector(".brand-page .full-width-wrapper:nth-of-type(2)");
	if (!arrowSectionDown || !secondSection) return;

	arrowSectionDown.addEventListener("click", function () {
		secondSection.scrollIntoView({ behavior: "smooth" });
	});
}

function loadPositions() {
	return fetch(JOBS_JSON_URL, { credentials: "omit" })
		.then(function (res) {
			if (!res.ok) throw new Error("Jobs JSON " + res.status);
			return res.json();
		})
		.then(function (data) {
			const list = Array.isArray(data?.positions) ? data.positions : [];
			return list
				.filter(isPublished)
				.slice()
				.sort(function (a, b) {
					return (a.priority || 0) - (b.priority || 0);
				});
		})
		.catch(function () {
			return [];
		});
}

function isPublished(position) {
	const today = new Date().toISOString().slice(0, 10);
	if (position.publishFrom && position.publishFrom > today) return false;
	if (position.publishTo && position.publishTo < today) return false;
	return true;
}

function renderJobs(positions) {
	const list = document.querySelector("[data-kariera-jobs]");
	if (!list) return;

	list.innerHTML = "";

	if (!positions.length) {
		const empty = document.createElement("p");
		empty.className = "kariera-jobs__empty";
		empty.textContent = "Aktuálně nemáme žádné otevřené pozice";
		list.appendChild(empty);
		return;
	}

	positions.forEach(function (position) {
		list.appendChild(buildJobCard(position));
	});
}

function buildJobCard(position) {
	const article = document.createElement("article");
	article.className = "kariera-job";
	article.dataset.positionId = position.id || "";

	const header = document.createElement("h2");
	header.className = "kariera-job__header";
	header.textContent = position.title || "";

	const body = document.createElement("div");
	body.className = "kariera-job__body";

	const meta = buildMetaLine(position);
	if (meta) body.appendChild(meta);

	(position.fields || []).forEach(function (field) {
		if (!field || META_FIELD_KEYS[field.key]) return;
		const value = (field.value || "").trim();
		if (!value) return;

		const section = document.createElement("div");
		section.className = "kariera-job__section";

		if (field.label) {
			const heading = document.createElement("h3");
			heading.textContent = field.label;
			section.appendChild(heading);
		}

		if (field.type === "html") {
			const content = document.createElement("div");
			content.className = "kariera-job__html";
			content.innerHTML = value;
			section.appendChild(content);
		} else {
			const text = document.createElement("p");
			text.textContent = value;
			section.appendChild(text);
		}

		body.appendChild(section);
	});

	const cta = document.createElement("a");
	cta.className = "kariera-cta-button kariera-cta-button--small";
	cta.href = "#kariera-form";
	cta.textContent = "Mám zájem";
	cta.dataset.positionTitle = position.title || "";
	body.appendChild(cta);

	article.appendChild(header);
	article.appendChild(body);
	return article;
}

function buildMetaLine(position) {
	const parts = [];
	if (position.salary) parts.push(position.salary);
	if (position.contractType?.label) parts.push(position.contractType.label);
	if (position.contractDuration?.label) parts.push(position.contractDuration.label);
	if (position.start?.label) parts.push(position.start.label);
	if (!parts.length) return null;

	const meta = document.createElement("p");
	meta.className = "kariera-job__meta";
	meta.textContent = parts.join(" · ");
	return meta;
}

function bindJobDropdowns() {
	document.querySelectorAll(".kariera-job").forEach(function (item) {
		const header = item.querySelector(".kariera-job__header");
		if (!header || header.dataset.bound === "1") return;
		header.dataset.bound = "1";

		header.addEventListener("click", function () {
			const wasOpen = item.classList.contains("expanded");
			document.querySelectorAll(".kariera-job.expanded").forEach(function (openItem) {
				openItem.classList.remove("expanded");
			});
			if (!wasOpen) {
				item.classList.add("expanded");
			}
		});
	});
}

function initApplyForm(positions) {
	const form = document.getElementById("kariera-apply");
	if (!form || form.dataset.bound === "1") return;
	form.dataset.bound = "1";

	const select = form.querySelector("#kariera-position");
	const statusBox = form.querySelector(".kariera-apply__status");
	const cvField = form.querySelector('[data-file="cv"]');
	const drop = cvField?.querySelector(".kariera-apply__drop");
	const cvInput = form.querySelector("#kariera-cv");
	let cvFile = null;

	populatePositionSelect(select, positions);

	document.querySelectorAll('.kariera-job a[href="#kariera-form"]').forEach(function (link) {
		link.addEventListener("click", function () {
			const title = link.dataset.positionTitle || link.closest(".kariera-job")?.querySelector(".kariera-job__header")?.textContent.trim();
			if (!title || !select) return;
			const option = Array.from(select.options).find(function (item) {
				return item.value === title;
			});
			if (option) {
				select.value = title;
				clearFieldError(select.closest(".kariera-apply__field"));
			}
		});
	});

	if (cvInput && drop && cvField) {
		cvInput.addEventListener("change", function () {
			setCvFile(cvInput.files[0], cvField, function (file) {
				cvFile = file;
			});
			cvInput.value = "";
		});

		["dragenter", "dragover"].forEach(function (eventName) {
			drop.addEventListener(eventName, function (event) {
				event.preventDefault();
				drop.classList.add("is-dragover");
			});
		});
		["dragleave", "drop"].forEach(function (eventName) {
			drop.addEventListener(eventName, function () {
				drop.classList.remove("is-dragover");
			});
		});
		drop.addEventListener("drop", function (event) {
			event.preventDefault();
			setCvFile(event.dataTransfer.files[0], cvField, function (file) {
				cvFile = file;
			});
		});
	}

	form.addEventListener("input", function (event) {
		const field = event.target.closest(".kariera-apply__field");
		if (field && !field.dataset.file) clearFieldError(field);
	});

	form.addEventListener("submit", async function (event) {
		event.preventDefault();
		if (statusBox) {
			statusBox.className = "kariera-apply__status";
			statusBox.textContent = "";
		}

		if (!validateApplyForm(form, cvFile)) {
			form.querySelector(".kariera-apply__field.is-invalid")?.scrollIntoView({
				behavior: "smooth",
				block: "center",
			});
			return;
		}

		const button = form.querySelector(".kariera-apply__submit");
		const originalLabel = button?.textContent;
		if (button) {
			button.disabled = true;
			button.textContent = "Odesílám…";
		}

		try {
			const payload = {};
			new FormData(form).forEach(function (value, key) {
				if (typeof value === "string") payload[key] = value;
			});
			payload.cv = {
				name: cvFile.name,
				type: cvFile.type,
				data: await fileToBase64(cvFile),
			};

			const res = await fetch(APPLY_ENDPOINT, {
				method: "POST",
				headers: { "Content-Type": "text/plain;charset=utf-8" },
				body: JSON.stringify(payload),
			});
			const result = await res.json();
			if (!result.ok) throw new Error(result.error || "submit failed");

			form.reset();
			cvFile = null;
			renderCvFile(cvField, null, function (file) {
				cvFile = file;
			});
			if (statusBox) {
				statusBox.textContent =
					"Děkujeme, vaše reakce byla odeslána. Ozveme se vám co nejdříve, nejpozději do 5 pracovních dnů.";
				statusBox.className = "kariera-apply__status is-ok";
			}
		} catch (err) {
			if (statusBox) {
				statusBox.textContent = "Reakci se nepodařilo odeslat. Zkontrolujte připojení a zkuste to znovu.";
				statusBox.className = "kariera-apply__status is-fail";
			}
		} finally {
			if (button) {
				button.disabled = false;
				button.textContent = originalLabel || "Odeslat reakci na pozici";
			}
		}
	});
}

function populatePositionSelect(select, positions) {
	if (!select) return;

	const placeholder = document.createElement("option");
	placeholder.value = "";
	placeholder.textContent = window.NAT.translations("karieraSelectPosition");

	select.innerHTML = "";
	select.appendChild(placeholder);

	positions.forEach(function (position) {
		if (!position.title) return;
		const option = document.createElement("option");
		option.value = position.title;
		option.textContent = position.title;
		select.appendChild(option);
	});

	const otherLabel = window.NAT.translations("karieraOtherPosition");
	const other = document.createElement("option");
	other.value = otherLabel;
	other.textContent = otherLabel;
	select.appendChild(other);
}

function setCvFile(file, field, assign) {
	if (!file) return;
	const extension = file.name.split(".").pop().toLowerCase();
	if (!CV_TYPES.includes(extension)) {
		setFieldError(field, "Nahrajte soubor ve formátu PDF, DOC nebo DOCX.");
		assign(null);
		renderCvFile(field, null, assign);
		return;
	}
	if (file.size > MAX_CV_BYTES) {
		setFieldError(field, "Soubor je větší než " + formatSize(MAX_CV_BYTES) + ".");
		assign(null);
		renderCvFile(field, null, assign);
		return;
	}
	clearFieldError(field);
	assign(file);
	renderCvFile(field, file, assign);
}

function renderCvFile(field, file, assign) {
	const list = field.querySelector(".kariera-apply__files");
	if (!list) return;
	list.innerHTML = "";
	if (!file) return;

	const item = document.createElement("li");
	const name = document.createElement("span");
	name.textContent = file.name;
	const size = document.createElement("span");
	size.className = "kariera-apply__size";
	size.textContent = formatSize(file.size);
	const remove = document.createElement("button");
	remove.type = "button";
	remove.textContent = "Odebrat";
	remove.setAttribute("aria-label", "Odebrat " + file.name);
	remove.addEventListener("click", function () {
		assign(null);
		renderCvFile(field, null, assign);
	});
	item.appendChild(name);
	item.appendChild(size);
	item.appendChild(remove);
	list.appendChild(item);
}

function validateApplyForm(form, cvFile) {
	let ok = true;

	form.querySelectorAll("input[required]:not([type=file]), select[required], input[type=email]").forEach(function (el) {
		const field = el.closest(".kariera-apply__field");
		if (!field) return;
		let message = "";
		if (el.type === "checkbox" && !el.checked) {
			message = "Pro pokračování je potřeba souhlas.";
		} else if (el.required && !String(el.value || "").trim()) {
			message = "Toto pole je povinné.";
		} else if (el.value && el.type === "email" && !el.checkValidity()) {
			message = "Zadejte platnou e-mailovou adresu.";
		}
		setFieldError(field, message);
		if (message) ok = false;
	});

	const cvField = form.querySelector('[data-file="cv"]');
	if (cvField) {
		if (!cvFile) {
			setFieldError(cvField, "Přiložte prosím svůj životopis.");
			ok = false;
		} else {
			clearFieldError(cvField);
		}
	}

	return ok;
}

function setFieldError(field, message) {
	if (!field) return;
	field.classList.toggle("is-invalid", !!message);
	const box = field.querySelector(".kariera-apply__error");
	if (box) box.textContent = message || "";
}

function clearFieldError(field) {
	setFieldError(field, "");
}

function formatSize(bytes) {
	if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + " KB";
	return (bytes / 1024 / 1024).toFixed(1).replace(".", ",") + " MB";
}

function fileToBase64(file) {
	return new Promise(function (resolve, reject) {
		const reader = new FileReader();
		reader.onload = function () {
			resolve(String(reader.result || "").split(",")[1] || "");
		};
		reader.onerror = reject;
		reader.readAsDataURL(file);
	});
}
